export default __webpack_public_path__ + "static/media/caretaker-2.ddd76d98.svg";